import { CameraConfiguration } from '../implementations/Camera/types';
import { CNCMachineConfiguration } from '../implementations/CNCMachine/types';
import { CustomBaseConfiguration } from '../implementations/CustomBase/types';
import { CustomDeviceConfiguration } from '../implementations/CustomDevice/types/CustomDeviceConfiguration';
import { CustomGripperConfiguration } from '../implementations/CustomGripper/types/CustomGripperConfiguration';
import { CustomIOConfiguration } from '../implementations/CustomIO/types/CustomIOConfiguration';
import { EwellixLiftTLTConfiguration } from '../implementations/EwellixLiftTLT/types';
import { FTPServerConfiguration } from '../implementations/FTPServer/types';
import { GPUTaskRunnerConfiguration } from '../implementations/GPUTaskRunner/types';
import { HapticDeviceConfiguration } from '../implementations/HapticDevice/types';
import { InvalidConfiguration } from '../implementations/InvalidConfiguration/types';
import { MiraiControllerConfiguration } from '../implementations/MiraiController/types';
import { ModbusTCPServerConfiguration } from '../implementations/ModbusTCPServer/types';
import { MountingAdapterConfiguration } from '../implementations/MountingAdapter/types';
import { MountingBracketConfiguration } from '../implementations/MountingBracket/types';
import { NoGripperConfiguration } from '../implementations/NoGripper/types';
import { OnRobot2FG14Configuration } from '../implementations/onRobot/OnRobot2FG14/types';
import { OnRobot2FG7Configuration } from '../implementations/onRobot/OnRobot2FG7/types';
import { OnRobot3FG15Configuration } from '../implementations/onRobot/OnRobot3FG15/types';
import { OnRobotDualQuickChangerConfigurationBase } from '../implementations/onRobot/OnRobotDualQuickChanger/types';
import { OnRobotHexEConfiguration } from '../implementations/onRobot/OnRobotHexE/types';
import { OnRobotScrewdriverConfiguration } from '../implementations/onRobot/OnRobotScrewdriver/types';
import { OnRobotVGP20Configuration } from '../implementations/onRobot/OnRobotVGP20/types';
import { Robotiq2FConfiguration } from '../implementations/robotiq/Robotiq2F/types';
import { RobotiqEPickConfiguration } from '../implementations/robotiq/RobotiqEPick/types';
import { RobotiqFT300Configuration } from '../implementations/robotiq/RobotiqFT300/types';
import { RobotiqTSF85Configuration } from '../implementations/robotiq/RobotiqTSF85/types';
import { S3BucketConfiguration } from '../implementations/S3Bucket/types';
import { SchunkEGxConfiguration } from '../implementations/schunk/SchunkEGx/types/SchunkEGxConfiguration';
import { StandardBotsRO1Configuration } from '../implementations/StandardBotsRO1/types/StandardBotsRO1Configuration';
import { EsabWeldMachineConfiguration } from '../implementations/WeldMachine/EsabWeldMachine/types/EsabWeldMachineConfiguration';
import { WeldMachineConfiguration } from '../implementations/WeldMachine/generic/types/WeldMachineConfiguration';
import { MillerWeldMachineConfiguration } from '../implementations/WeldMachine/MillerWeldMachine/types/MillerWeldMachineConfiguration';
import { WeldPositionerConfiguration } from '../implementations/WeldPositioner/types';
import { WristCameraConfiguration } from '../implementations/WristCamera/types';

/**
 * DeviceConfiguration is the configuration for a device.
 * Configuration can include information such as IP address, port, finger width, etc.
 *
 * Configuration is passed into the core device implementation when the device is created.
 */
export const DeviceConfigurationRegistry = [
  MountingAdapterConfiguration,
  MountingBracketConfiguration,
  OnRobotDualQuickChangerConfigurationBase,
  OnRobotScrewdriverConfiguration,
  OnRobotVGP20Configuration,
  OnRobot2FG7Configuration,
  OnRobot2FG14Configuration,
  OnRobot3FG15Configuration,
  Robotiq2FConfiguration,
  RobotiqEPickConfiguration,
  CustomGripperConfiguration,
  EwellixLiftTLTConfiguration,
  NoGripperConfiguration,
  CustomIOConfiguration,
  CustomDeviceConfiguration,
  CustomBaseConfiguration,
  InvalidConfiguration,
  ModbusTCPServerConfiguration,
  FTPServerConfiguration,
  S3BucketConfiguration,
  WristCameraConfiguration,
  SchunkEGxConfiguration,
  CNCMachineConfiguration,
  StandardBotsRO1Configuration,
  WeldMachineConfiguration,
  MillerWeldMachineConfiguration,
  EsabWeldMachineConfiguration,
  OnRobotHexEConfiguration,
  RobotiqFT300Configuration,
  GPUTaskRunnerConfiguration,
  CameraConfiguration,
  MiraiControllerConfiguration,
  HapticDeviceConfiguration,
  RobotiqTSF85Configuration,
  WeldPositionerConfiguration,
] as const;
